let data = require('../datasets/countries.json')

export default data.countries;